import React, { useEffect, useState } from "react";
import {
	Box,
	Typography,
	TextField,
	Button,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	CircularProgress,
	Alert,
	InputAdornment,
} from "@mui/material";
import {
	Search as SearchIcon,
	Edit as EditIcon,
	Delete as DeleteIcon,
} from "@mui/icons-material";
import AppLayout from "../../components/AppLayout";
import { UnidadeDistribuidorService } from "../../service/unidade_distribuidor_service";

function UnidadesDistribuidoras() {
	const [unidades, setUnidades] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");
	const [searchTerm, setSearchTerm] = useState("");

	useEffect(() => {
		const loadUnidades = async () => {
			try {
				setIsLoading(true);
				setError("");
				const unidadeService = new UnidadeDistribuidorService();
				const result = await unidadeService.getAll(1, 1000);
				setUnidades(result.data || []);
			} catch (err) {
				setError(err.message);
			} finally {
				setIsLoading(false);
			}
		};

		loadUnidades();
	}, []);

	const filteredUnidades = unidades.filter((unidade) =>
		unidade.nome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
		unidade.cpf_cnpj?.includes(searchTerm)
	);

	return (
		<AppLayout currentPage="distribuidora">
			<Box sx={{ maxWidth: 1400, mx: "auto" }}>
					{/* Header */}
					<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
						<Typography
							variant="h4"
							sx={{
								color: "#666",
								fontWeight: 700,
							}}
						>
							Unidade de Distribuição
						</Typography>
						<Button
							variant="contained"
							sx={{
								bgcolor: "#1a9e8f",
								color: "white",
								fontWeight: 600,
								px: 4,
								py: 1.5,
								borderRadius: "8px",
								textTransform: "none",
								fontSize: "16px",
								"&:hover": {
									bgcolor: "#138a7d",
								},
							}}
						>
							Nova Unidade
						</Button>
					</Box>

					{/* Search Bar */}
					<Box sx={{ mb: 3 }}>
						<TextField
							fullWidth
							placeholder="Pesquisar"
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon sx={{ color: "#999" }} />
									</InputAdornment>
								),
							}}
							sx={{
								maxWidth: 800,
								bgcolor: "white",
								borderRadius: "8px",
								"& .MuiOutlinedInput-root": {
									"& fieldset": {
										borderColor: "#E0E0E0",
									},
									"&:hover fieldset": {
										borderColor: "#1a9e8f",
									},
									"&.Mui-focused fieldset": {
										borderColor: "#1a9e8f",
									},
								},
							}}
						/>
					</Box>

					{/* Content */}
					{error && (
						<Alert severity="error" sx={{ mb: 3 }}>
							{error}
						</Alert>
					)}

					{isLoading ? (
						<Box sx={{ display: "flex", justifyContent: "center", p: 8 }}>
							<CircularProgress sx={{ color: "#1a9e8f" }} />
						</Box>
					) : (
						<Box
							sx={{
								bgcolor: "white",
								borderRadius: "12px",
								overflow: "hidden",
								boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
							}}
						>
							<TableContainer>
								<Table>
									<TableHead>
										<TableRow sx={{ bgcolor: "#F8F9FA" }}>
											<TableCell sx={{ fontWeight: 700, color: "#1a9e8f", fontSize: "15px" }}>
												Código
											</TableCell>
											<TableCell sx={{ fontWeight: 700, color: "#1a9e8f", fontSize: "15px" }}>
												Razão Social
											</TableCell>
											<TableCell sx={{ fontWeight: 700, color: "#1a9e8f", fontSize: "15px" }}>
												Nome Fantazia
											</TableCell>
											<TableCell sx={{ fontWeight: 700, color: "#1a9e8f", fontSize: "15px" }}>
												CPF/CNPJ
											</TableCell>
											<TableCell sx={{ fontWeight: 700, color: "#1a9e8f", fontSize: "15px", textAlign: "center" }}>
												Ações
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{filteredUnidades.length === 0 ? (
											<TableRow>
												<TableCell colSpan={5} align="center">
													<Typography variant="body2" sx={{ color: "#999", py: 8 }}>
														Nenhuma unidade distribuidora encontrada
													</Typography>
												</TableCell>
											</TableRow>
										) : (
											filteredUnidades.map((unidade, index) => (
												<TableRow
													key={unidade.id}
													hover
													sx={{
														"&:hover": {
															bgcolor: "#F8F9FA",
														},
													}}
												>
													<TableCell sx={{ color: "#333", fontSize: "14px" }}>
														{String(index + 1).padStart(2, '0')}
													</TableCell>
													<TableCell sx={{ color: "#333", fontSize: "14px" }}>
														{unidade.nome}
													</TableCell>
													<TableCell sx={{ color: "#333", fontSize: "14px" }}>
														{unidade.nome}
													</TableCell>
													<TableCell sx={{ color: "#333", fontSize: "14px" }}>
														{unidade.cpf_cnpj}
													</TableCell>
													<TableCell sx={{ textAlign: "center" }}>
														<IconButton size="small" sx={{ color: "#1a9e8f", mr: 1 }}>
															<EditIcon fontSize="small" />
														</IconButton>
														<IconButton size="small" sx={{ color: "#ff4d4d" }}>
															<DeleteIcon fontSize="small" />
														</IconButton>
													</TableCell>
												</TableRow>
											))
										)}
									</TableBody>
								</Table>
							</TableContainer>
						</Box>
					)}
			</Box>
		</AppLayout>
	);
}

export default UnidadesDistribuidoras;
